import { Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import React from "react";

function RegisterPage() {
  return (
    <PageLayout>
      <DefaultCard title="REGISTER">
        <Typography variant="h4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://form.jotform.com/260863584960973"
          >
            Register for Harmony Hill 2026
          </a>
        </Typography>
      </DefaultCard>
    </PageLayout>
  );
}

export default RegisterPage;
